import Image from "next/image"

import { PREMIUM_FEATURES } from "../../lib/premium-plans"

// The old /sign-up page's side panel next to its plan step. Lists the same
// Premium features as /pricing and the upgrade dialog. (It used to live in
// pages/sign-up/components, which made it a public page of its own.)
const SignupPremium = () => (
  <div>
    <div className="signup__heading">What you get with Premium:</div>
    <div className="upgrade__content__section">
      <div className="upgrade__medal__section">
        <Image src="/static/images/medal.svg" alt="" height={80} width={60} priority />
      </div>
      <ul className="upgrade__section__list">
        {PREMIUM_FEATURES.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </div>
  </div>
)

export default SignupPremium
